<template>

  <a-modal
    title="新增游戏"
    :width="1100"
    :visible="visible"
	@cancel="handleCancel"
    :maskClosable="false"
    :footer="null"
    :bodyStyle="{'padding':'10px'}"
    >
    <div class="template-act-list" >
      <ul class="template-list-ul">
        <li class="template-item" v-for="(tem,index) in gameTmlList" :key="index">
          <div class="template-name">
            {{tem.gameName}}
          </div>
          <div class="template-img">
            <div class="template-img-con">
              <img src="../../../../assets/elinkx/myCourse/gameCourse/lianlian.jpg" alt="" v-if="tem.gameType==1">
              <img src="../../../../assets/elinkx/myCourse/gameCourse/draw.jpg" alt="" v-if="tem.gameType==8">
              <img src="../../../../assets/elinkx/myCourse/gameCourse/findThing.png" alt="" v-if="tem.gameType==7">
              <img src="../../../../assets/elinkx/myCourse/gameCourse/color.jpg" alt="" v-if="tem.gameType==4">
              <img src="../../../../assets/elinkx/myCourse/gameCourse/shoot.jpg" alt="" v-if="tem.gameType==3">
              <img src="../../../../assets/elinkx/myCourse/gameCourse/findSame.jpg" alt="" v-if="tem.gameType==6">
              <img src="../../../../assets/elinkx/myCourse/gameCourse/findAnswer.jpg" alt="" v-if="tem.gameType==2">
			  <img src="../../../../assets/elinkx/myCourse/gameCourse/dragImg.jpg" alt="" v-if="tem.gameType==5">
              <div class="hover-div">
                <div class="hover-div-bg">

                </div>
                <div class="btn-list-div">
                  <a-button type="primary" icon="right-circle" style="margin:10px;" @click="selectTem(tem)">
                    选择模板
                  </a-button>
                  <!-- <span class="act-scan"></span> -->
                </div>
              </div>
            </div>
            
          </div>
        </li>
      </ul>
    </div>
  </a-modal>
</template>

<script>

  // import moment from 'moment'
  // import pick from 'lodash.pick'
  // import { FormTypes } from '@/utils/JEditableTableUtil'
  // import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'

  import {getGameTemList} from '@/api/api'

  export default {
    name: 'GameTypeSelectModal',
    mixins: [],
    props:[],
    data() {
      return {
        visible:false,
        selectCurType:1,//1-词卡，2-视频，3-图文，4-音频，5-游戏）
        chapterId:"",
        gameTmlList:[]
      }
    },
    methods: {
      handleOk(){
        this.visible = false;
        if(this.selectCurType==1){
          this.$router.push({ path:'/myCourse/gameEditor?courseId='+this.courseId+"&chapterId="+this.chapterId});
        }
      },
      handleCancel(){
        this.visible = false;
      },
      add () {
        this.visible = true;
        this.getGameTelList();
        // this.chapterId = id;
      },
      getGameTelList(){

        getGameTemList().then((res)=>{
          if(res.success==true){
            this.gameTmlList = res.result.records || []
            
          }else{
            this.$message.warning(res.message);
          }

        }).finally(() => {
          // that.confirmLoading = false;
          // that.checkedDepartNames = [];
          // that.userDepartModel.departIdList = {userId:'',departIdList:[]};

          // that.close();
        })
      },
      selectTem(tem){
		// if(tem.gameType == "1"){
		// 	this.$router.push({ path:'/myCourse/gameEditor?id='+tem.id});
		// }else if(tem.gameType == "3"){
		// 	this.$router.push({ path:'/myCourse/shootGameCreate?id='+tem.id});
		// }
		let type = tem.gameType;
		let id = tem.id;
		if(type=="1"||type=="6"||type=="7"||type=="2"){
          this.$router.push({ path:'/myCourse/gameEditor?id='+id});
        }else if(type=="3"){
          this.$router.push({ path:'/myCourse/shootGameCreate?id='+id});
        }else if(type=="4"||type=="8"){
          this.$router.push({ path:'/myCourse/drawGameCreate?id='+id});
        }else if(type=="5"){
          this.$router.push({ path:'/myCourse/gameEditor?id='+id});
        }

      }
    }
  }
</script>

<style lang="scss" scoped >
  .template-act-list{
	.template-list-ul{
    overflow: hidden;
		.template-item{
			border:1px solid #eeeeee;
			width: 230px;
			margin-right: 20px;
			margin-bottom: 10px;
			float: left;
			height: 257px;
			transition-duration: 0.5s;
			&:hover{
				border-color:#1890FF;
			}
			&:nth-child(4n){
				margin-right: 0px;
			}
			.template-name{
				color:#333;
				font-size: 14px;
				line-height: 30px;
				height: 30px;
				text-align:center;
			}
			.template-img{	
				padding: 0px 20px;
				&:hover{
					.hover-div{
						transform: translateY(0%);
					}
				}
				.template-img-con{
					
					position: relative;
					overflow: hidden;
					height: 207px;

					img{
						width:100%;
					}
				}
				
				.hover-div{
					position: absolute;
					width: 100%;
					height: 50px;
					left: 0px;bottom: 0px;
					transform: translateY(100%);
					transition-duration: 0.5s;
					.hover-div-bg{
						background-color: #000;
						opacity: .5;
						left: 0px;bottom: 0px;
						width: 100%;height: 100%;
						position: absolute;
						z-index:10;
					}
					.btn-list-div{
						left: 0px;bottom: 0px;
						width: 100%;height: 100%;
						position: absolute;
						z-index:11;
						.icon-rightA{
							width: 12px;
							height: 12px;
							display: inline-block;
							// background-image: url('../../img/rightA.png');
							background-size: 100% 100%;
							margin-left: 5px;
							vertical-align: middle;
						}
						.btn-blue{
							width: 80px;
							height: 30px;
							line-height: 28px;
							text-align:center;
							margin-top: 10px;
							margin-left:10px;
							background-color: #1890FF;
							color:#fff;
							border-radius:3px;
							cursor: pointer;

						}
						.act-scan{
							color: #fff;margin-left: 20px;cursor: pointer;
						}
						.btn-text{
							vertical-align: middle;
						}
					}	
					
				}
			}
			.template-desc{color:#999999;font-size: 12px;padding: 9px 25px;}
			.temp-blank-img{
				text-align:center;
				margin-top: 105px;
				img{
					width: 40px;
				}
				cursor: pointer;
			}
			.temp-blank-text{
				color: #1890FF;
				font-size: 14px;
				text-align:center;
				margin-top: 5px;
				cursor: pointer;
			}

		}
	}
}
</style>